import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
import { CustomerInfoProviderInterface } from "@lib/CustomerInfoProvider/CustomerInfoProviderInterface";
import { LocalizationInfoProviderInterface } from "@lib/LocalizationInfoProvider/LocalizationInfoProviderInterface";

import { WishlistsSharedStateKitQueryWrapper } from "./WishlistsSharedStateKitQueryWrapper";
import { WishlistsSharedStateKitServiceWrapper } from "./WishlistsSharedStateKitServiceWrapper";

export class WishlistsSharedStateKit {
    public readonly query: WishlistsSharedStateKitQueryWrapper;
    public readonly service: WishlistsSharedStateKitServiceWrapper;

    constructor(
        wishlistsQuery: WishlistsQuery,
        wishlistsService: WishlistsService,
        localizationInfoProvider: LocalizationInfoProviderInterface,
        customerInfoProvider: CustomerInfoProviderInterface
    ) {
        this.query = new WishlistsSharedStateKitQueryWrapper(wishlistsQuery);
        this.service = new WishlistsSharedStateKitServiceWrapper(
            wishlistsService,
            wishlistsQuery,
            localizationInfoProvider,
            customerInfoProvider
        );
    }
}
